/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize CountryUserRoles Management View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './countryUserRolesManagementView';

export const mapStateToPropsCURManagement = mapStateToProps;
export const mapDispatchToPropsCURManagement = mapDispatchToProps;

export default connect(
  mapStateToPropsCURManagement,
  mapDispatchToPropsCURManagement
)(View);
